import React from 'react';
import type { FullLayoutProps } from '@v2/shared/lib/types';

import Content from './Content';
import Footer from './Footer';
import Navigation from './Navigation';

/**
 * The chrome every MagZoom page shares.
 *
 * MagSpot's sibling, and ported the same way: from the site's own legacy tSys templates
 * (`domain-overrides/magzoom.com/layouts/full/header.html` and `.../footer.html`), since
 * MagZoom never had a headless app either.
 *
 * The two brands render a header of the same shape — the legacy stylesheets say so
 * outright, MagSpot's `main.scss` being MagZoom's plus a footer override — and so, near
 * enough, does TopMags'. The pieces all three draw live in `shared/Layouts/Full`; what
 * each brand owns is the arrangement of them and its own mark.
 *
 * Where MagZoom does differ from MagSpot: its header carries the About/FAQ/Contact links
 * beside the account ones, and its footer runs the ResellerRatings seal instead of a
 * coloured band.
 */
export default function Full({
  children,
  displaySitewideBanner,
  categories,
  copyrightYear,
}: FullLayoutProps) {
  return (
    <div className="flex flex-col min-h-screen bg-white">
      <Navigation categories={categories} />
      <Content>{children}</Content>
      <Footer copyrightYear={copyrightYear} />
    </div>
  );
}
